export function getClientHeaders(): Promise<Record<string, string>> {
  throw new Error('getClientHeaders has not been implemented for this platform')
}
